/* eslint-disable @typescript-eslint/no-explicit-any */
import { KeyFilterType } from 'primereact/keyfilter';
import { ChangeEvent, CSSProperties, ReactNode } from 'react';
import { UseFormRegisterReturn } from 'react-hook-form';

export enum TextfieldType {
  INPUT = 'input',
  TEXTAREA = 'textarea',
}

export type TexfieldProps = {
  placeholder?: string;
  labelStyle?: CSSProperties;
  inputStyle?: CSSProperties;
  borderStyle?: string;
  textAreaStyle?: CSSProperties;
  label?: string;
  keyfilter?: KeyFilterType;
  type?: string;
  name?: string;
  helpText?: string;
  icon?: ReactNode;
  onClickIcon?: () => void;
  handleChange?: (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => void;
  value?: string;
  textFieldType: TextfieldType.INPUT | TextfieldType.TEXTAREA;
  register?: UseFormRegisterReturn;
  errorStyle?: string;
  className?: string;
  iconPosition?: IconPosition;
  rows?: number;
};

export enum IconPosition {
  LEFT = 'left',
  RIGHT = 'right',
}
